<template>
  <div class="form-group">
    <label
      v-if="label"
      :for="id"
    >
      {{label}}
    </label>

    <select
      :value="value"
      :class="classInput"
      :id="id"
      :placeholder="placeholder || label"
      @input="$emit('input', $event.target.value)"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{option.label}}
      </option>
    </select>

    <div
      v-if="error"
      class="invalid-feedback"
    >
      {{error}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
      error: {
        type: String,
      },
      value: {},
      options: {
        type: Array,
        required: true,
      },
      label: {
        type: String,
      },
      placeholder: {
        type: String,
      },
    },

    computed: {
      classInput() {
        return {
          'form-control': true,
          'is-invalid': this.error,
        }
      },
    },
  }
</script>

<style>

</style>
